import { createContext } from "react";
import type { TemplateContextType } from "@/providers/TemplateProvider";

export const TemplateWithFieldsContext = createContext<TemplateContextType | null>(null);
